// Where clicking a notification should take the user. Shared by the top-bar dropdown and the
// Notifications page so both behave the same.

const adminRoute = (n) => {
  const id = n.linkId;
  const ref = n.linkRef;
  switch (n.type) {
    case 'order':
    case 'cancelled':
    case 'payment':
    case 'wallet':
      return id && (ref === 'Order' || n.type === 'order' || n.type === 'cancelled') ? `/ordermanagement/${id}` : '/ordermanagement';
    case 'return':
      return '/reports/returns';
    case 'shipment':
      return '/ordermanagement';
    case 'product':
      return id ? `/productmanagement/view/${id}` : '/productmanagement';
    case 'category':
    case 'subcategory':
      return '/categories';
    case 'coupon':
      return id ? `/couponsmanagement/${id}` : '/couponsmanagement';
    case 'customer':
      return '/customermanagement';
    case 'user':
      return '/usermangement';
    case 'seller':
      return id ? `/sellermanagement/${id}` : '/sellermanagement';
    case 'seller_request':
      return '/productrequestlist';
    case 'seller_order':
      return id ? `/onlineorders/${id}` : '/onlineorders';
    case 'stock':
      return '/inventorymanagement';
    case 'rating':
      return '/reports/customer-ratings';
    case 'reward':
    case 'rewardConfig':
      return '/rewards';
    case 'query':
      return id ? `/queries/chat/${id}` : '/queries';
    case 'packing':
    case 'picking':
    case 'rack':
      return '/warehouse';
    default:
      return null;
  }
};

// Pages a seller account can open (the seller area has fewer pages than the admin one).
const SELLER_PAGES = [/^\/ordermanagement(\/|$)/, /^\/productmanagement(\/|$)/, /^\/onlineorders(\/|$)/, /^\/productrequestlist$/, /^\/inventorymanagement$/, /^\/sellerpayout$/, /^\/couponsmanagement(\/|$)/];

export const getNotificationRoute = (n, isVendor = false) => {
  const fallback = isVendor ? '/seller/notification' : '/notification';
  const target = adminRoute(n || {});
  if (!target) return fallback;
  if (!isVendor) return target;
  return SELLER_PAGES.some((rx) => rx.test(target)) ? `/seller${target}` : fallback;
};
